import React, { useCallback } from 'react';
import useInactivityTimer from './useInactivityTimer';
import InactivityDialog from './InactivityDialog';
import { refreshpostApiAsyn } from '../../services/PostAPI';

const InactivityHandler = ({
  timeout = 25,
  warningTime = 60,
}) => {
  const token = localStorage.getItem('token');
  const isLoggedIn = token && token !== '' && token !== 'null' && token !== 'undefined';

  const handleLogout = useCallback(() => {
    localStorage.clear();
    window.location.replace("/");
  }, []);

  const handleContinue = useCallback(async () => {
    try {
      // Check if token still exists before attempting refresh
      const currentToken = localStorage.getItem('token');
      if (!currentToken || currentToken === 'null' || currentToken === 'undefined') {
        console.error('No valid token found, logging out');
        handleLogout();
        return;
      }
      
      const response = await refreshpostApiAsyn('auth/refreshToken', currentToken);
      
      // Check if refresh failed (401 or error response)
      if (response?.APIResult === 0 || !response?.token) {
        console.error('Token refresh failed:', response?.Message || 'No token received');
        handleLogout();
        return;
      }
      
      const newToken = response?.token;
      
      if (newToken) {
        localStorage.removeItem('token');
        localStorage.setItem('token', newToken);
        localStorage.setItem('lastActivity', Date.now().toString());
      } else {
        // No valid token received, logout
        handleLogout();
      }
    } catch (error) {
      console.error('Token refresh error:', error);
      handleLogout();
    }
  }, [handleLogout]);

  const {
    isWarningVisible,
    remainingTime,
    handleContinue: continueSession,
    handleLogout: logoutSession,
  } = useInactivityTimer({
    timeout: timeout * 60 * 1000,
    warningTime: warningTime * 1000,
    onTimeout: handleLogout,
    onContinue: handleContinue,
    enabled: isLoggedIn,
  });

  if (!isLoggedIn) {
    return null;
  }

  return (
    <InactivityDialog
      open={isWarningVisible}
      remainingTime={remainingTime}
      onContinue={continueSession}
      onLogout={logoutSession}
    />
  );
};

export default InactivityHandler;
